import { Button, Flex } from "@chakra-ui/react"
import dynamic from "next/dynamic"
import { Dispatch, SetStateAction } from "react"
import { mobileMenuSectionNames, pages } from "../../../../../common/constants/constants"
import { useBrandedTranslation } from "../../../../../common/hooks/useBrandedTranslation"
import { useAuth } from "../../../../../common/hooks/useGigya"
import { MobileMenuSectionNamesType } from "../../../../../common/types/global"
import { ChakraNextLinkButton } from "../../../../shared/ChakraNextLinkButton"
import { CGeberitId, CLists, CSettings } from "../../../../shared/Icons"
import LogoutButton from "../LogoutButton"

/* LoginButton depends on Gigya data, that's why it needs to be client-side rendered only */
const LoginButton = dynamic(() => import("../LoginButton"), { ssr: false })

type Props = {
  activeMenu: MobileMenuSectionNamesType
  setActiveMenu: Dispatch<SetStateAction<MobileMenuSectionNamesType>>
  handleCloseMenu: () => void
}

const MobileAccountMenu = ({ activeMenu, setActiveMenu, handleCloseMenu }: Props) => {
  const { t } = useBrandedTranslation()
  const { accountInfo } = useAuth()
  const isUserLoggedIn = !!accountInfo.userId

  return (
    <Flex flexDirection="column" fontSize="sm" fontWeight="medium" color="black">
      <LoginButton handler={handleCloseMenu} />
      {activeMenu !== mobileMenuSectionNames.MY_LISTS_MENU && (
        <Button
          variant="mobileMenu"
          aria-label="Open My Lists section"
          color="black"
          iconSpacing="3"
          leftIcon={<CLists />}
          onClick={() => setActiveMenu(mobileMenuSectionNames.MY_LISTS_MENU)}
        >
          {t("acc-myLists")}
        </Button>
      )}
      {isUserLoggedIn && (
        <>
          <ChakraNextLinkButton
            href={`/${pages.SETTINGS}`}
            variant="mobileMenu"
            aria-label="Go to User Settings"
            color="black"
            iconSpacing="3"
            leftIcon={<CSettings />}
            label={t("acc-lst-settings")}
            onClick={handleCloseMenu}
          />
          <ChakraNextLinkButton
            href={`/${pages.GEBERIT_ID}`}
            variant="mobileMenu"
            aria-label="Go to User Profile"
            color="black"
            iconSpacing="3"
            leftIcon={<CGeberitId />}
            label={t("acc-lst-geberitId")}
            onClick={handleCloseMenu}
          />
          <LogoutButton isMenu={true} handler={handleCloseMenu} />
        </>
      )}
    </Flex>
  )
}

export default MobileAccountMenu
